/** Canonical marketing site origin (matches prod CloudFront). */
export const SITE_ORIGIN = 'https://www.occasia.io';

export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/occasia.svg`;

export const DEFAULT_TITLE = 'Occasia — Book unique event venues in the UK';

export const DEFAULT_DESCRIPTION =
  'Find and book pubs, cafés, and event spaces for parties, workshops, and private hire. Compare capacity and pricing, enquire online, or list your venue on Occasia.';

export const DEFAULT_KEYWORDS =
  'venue hire UK, event space London, book a venue, private hire, party venue, workshop space, corporate event venue, list your venue, Occasia';
